import { render, staticRenderFns } from "./PodHeader.vue?vue&type=template&id=0bca8d5b&scoped=true&"
import script from "./PodHeader.vue?vue&type=script&lang=js&"
export * from "./PodHeader.vue?vue&type=script&lang=js&"
import style0 from "./PodHeader.vue?vue&type=style&index=0&id=0bca8d5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bca8d5b",
  null
  
)

export default component.exports